import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class FixedAssetService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

  getMaxId() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/fixed-asset/getMaxId`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/fixed-asset`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    addFixedAsset(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/fixed-asset`,  data)
        .pipe(catchError(this.handleError));
       
    }


    updateFixedAsset(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/fixed-asset`, data)
        .pipe(catchError(this.handleError));
       
    }

    deleteFixedAsset(itemCode: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/fixed-asset/${itemCode}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    //////////////Disposal///////////////

    getAllDisposedAssets():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/fixed-asset-disposal`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }
  
  
      addFixedAssetDisposal(data):Observable <any>{
        return this.http.post<any>(`${this.env.apiUrl}/fixed-asset-disposal`,  data)
          .pipe(catchError(this.handleError));
         
      }
  

  
      deleteFixedAssetDisposal(id: string) : Observable <void>{
        return this.http.delete<void>(`${this.env.apiUrl}/fixed-asset-disposal/${id}`,httpOptions)
          .pipe(catchError(this.handleError));
         
      }


      //////////////Allocation///////////////

    getAllFixedAssetAllocation():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/fixed-asset-allocation`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }
  
  
      addFixedAssetAllocation(data):Observable <any>{
        return this.http.post<any>(`${this.env.apiUrl}/fixed-asset-allocation`,  data)
          .pipe(catchError(this.handleError));
         
      }
  
      updateFixedAssetAllocation(data):Observable <void>{
        return this.http.put<void>(`${this.env.apiUrl}/fixed-asset-allocation`, data)
          .pipe(catchError(this.handleError));
         
      }
  
      deleteFixedAssetAllocation(id: string) : Observable <void>{
        return this.http.delete<void>(`${this.env.apiUrl}/fixed-asset-allocation/${id}`,httpOptions)
          .pipe(catchError(this.handleError));
         
      }




    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }



}
